import React from 'react';
import PublicPageLayout from '../components/marketing/PublicPageLayout';
import PricingComponent from '../components/PricingComponent';

const Pricing = () => (
  <PublicPageLayout>
    <PricingComponent />
  </PublicPageLayout>
);

export default Pricing;
